import EditorBaseComponentVO from './editorbasecomponentvo.js';

export default class PMWSliderComponentVO extends EditorBaseComponentVO {
    /**
     * @param {string} property
     * @param {string} propertyLabel
     * @param {string} units
     * @param {number} min
     * @param {number} max
     * @param {object} [opts={}]
     * @param {number|string} [opts.defaults=0]
     * @param {number} [opts.step=1]
     * @param {boolean} [opts.extendedControls=false]
     * @param {ExtendedControlIcons} [opts.extendedControlIcons=null]
     * @param {Component|null} [opts.component=null]
     * @param {boolean} [opts.isResponsive=false] whether component will allow different values to be set for tablet/mobil media queries
     * @param {string} [opts.toggleProp=''] style property option to show/hide if slider value > 0
     */
    constructor(property, propertyLabel, units, min, max, opts={}) {
        opts.defaults = opts.defaults || 0;
        opts.step = opts.step || 1;
        opts.extendedControls = opts.extendedControls || false;
        opts.extendedControlIcons = opts.extendedControlIcons || null;
        opts.component = opts.component || null;
        opts.isResponsive = opts.isResponsive || false;
        opts.toggleProp = opts.toggleProp || '';

        super(property, propertyLabel, units, min, max, opts.defaults, window.PMW.emails.styles.ID_SLIDER, opts.extendedControls, opts.component, opts.isResponsive, opts.extendedControlIcons);
        this._step = opts.step;
        this._min = min;
        this._toggleProp = opts.toggleProp;
    }

    get step() {
        return this._step;
    }

    set min(value) {
        this._min = value;
    }

    get min() {
        return this._min;
    }

    get toggleProp() {
        return this._toggleProp;
    }

    set toggleProp(value) {
        this._toggleProp = value;
    }

    toObject() {
        let obj = super.toObject();
        obj.step = this.step;
        obj.min = this.min;
        obj.toggleProp = this.toggleProp;

        return obj;
    }
}
